import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonLink,
  H3,
  Paragraph,
  Link,
  StatusLabel,
} from '@studio/legacy-components';
import useToggle from 'next/hooks/use-toggle';
import SegmentModal from './SegmentModal';
import { WebCardWrapper, Footer, WebBody, UpperContent } from './styled';

const WebCard = ({ installed }) => {
  const [open, toggle] = useToggle(false);

  return (
    <>
      <SegmentModal open={open} onClose={toggle} />
      <WebCardWrapper>
        <WebBody>
          <UpperContent>
            <H3>Web application</H3>
            <Paragraph>
              <Link to="/settings/installation/guide/overview">Open guide</Link>{' '}
              to install on a new domain, add a user property or event, and
              more. Or use <ButtonLink onClick={toggle}>Segment</ButtonLink> to
              install Appcues.
            </Paragraph>
          </UpperContent>
          {installed && (
            <Footer>
              <StatusLabel icon="check-circle" active label="Installed" />
            </Footer>
          )}
        </WebBody>
      </WebCardWrapper>
    </>
  );
};

WebCard.propTypes = {
  installed: PropTypes.bool,
};

export default WebCard;
